import React from "react";
import TrailTable from "components/common/TrailTable/TrailTable";

interface Props {
  entityId: string | number;
}

const PartnersTrailTab: React.FC<Props> = ({ entityId }) => {
  return <TrailTable entityType="footerPartners" entityId={Number(entityId)} />;
};

export default PartnersTrailTab;
